import { useRouter } from 'next/router';
import { mutate } from 'swr';
import { FunctionComponent } from 'react';
import { CommunityShotItem } from 'types/community';
import ConfirmDialog from './ConfirmDialog';
import { getCommunityPath, getCommunityProfilePostsUrl } from 'lib/community';

function getDeletePostUrl(shotItem: CommunityShotItem) {
  const { NEXT_PUBLIC_API: domain } = process.env;
  const { communityPostId } = shotItem;
  return `${domain}/api/community-posts/${communityPostId}`;
}

type ConfirmDeleteCommunityPostProps = {
  display: boolean;
  onCancel: () => void;
  shotItem: CommunityShotItem;
};

const ConfirmDeleteCommunityPost: FunctionComponent<
  ConfirmDeleteCommunityPostProps
> = ({ display, onCancel, shotItem }) => {
  const router = useRouter();

  const { ownerId } = shotItem;

  async function onConfirm() {
    const url = getDeletePostUrl(shotItem);
    await fetch(url, { method: 'DELETE', credentials: 'include' });

    // revalidate swr caches where this post could occur
    await mutate('/api/community-posts', [], false);
    await mutate('/api/community-posts/featured', [], false);
    await mutate(getCommunityProfilePostsUrl(ownerId.toString()), [], false);

    // Redirect to the community page after delete is complete
    router.replace(getCommunityPath());
  }

  return (
    <ConfirmDialog
      display={display}
      title="Delete Post"
      caption="Are you sure you want to delete this post and all its versions from the community?"
      confirmLabel="Yes, delete my post"
      cancelLabel="No, take me back"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default ConfirmDeleteCommunityPost;
